import { useMemo } from 'react';

import type { SuggestedAction } from '@verantos-dev/shared-components';

import { useConceptGroupSuggestedActions } from './useConceptGroupSuggestedActions';

export const useSuggestedActions = ({
  onUserPromptChange,
  useConceptGroupActions = useConceptGroupSuggestedActions,
}: {
  onUserPromptChange: (prompt: string) => void;
  useConceptGroupActions?: (options: {
    onUserPromptChange: (prompt: string) => void;
  }) => SuggestedAction[] | undefined;
}) => {
  const conceptGroupActions = useConceptGroupActions({ onUserPromptChange });

  const suggestedActions = useMemo(() => {
    const actions: SuggestedAction[] = [];

    // Add concept group actions if available (feature opt-in handled by the hook)
    if (conceptGroupActions) {
      actions.push(...conceptGroupActions);
    }

    // Return empty array if no actions, otherwise return actions
    return actions.length > 0 ? actions : [];
  }, [conceptGroupActions]);

  return suggestedActions;
};
